module.exports = __webpack_public_path__ + "img/feature_f01.ba782b0d.svg";